import { createContext, PropsWithChildren } from "react";
import { useStore } from "@ludens-reklame/rubics-v3-react/store/hooks";
import { ThemeSettings } from "../types/theme.js";
import { DataBuckets } from "../types/data-buckets.js";
import { PageProps } from "../types/common.js";
import { getContrastTextColor } from "../client-utils/getConstrastColor.js";

interface IContext { }

export const CourseContext = createContext<IContext>({});

/**
 * This course context has only one purpose, and that is
 * to read from page context and inject color variables
 * so that the component tree has them available.
 *
 * @returns children
 */
export const CourseProvider: React.FC<PropsWithChildren> = ({ children }) => {
  const store = useStore<ThemeSettings, DataBuckets, PageProps>();
  const courseCategory = store.context?.page?.props?.courseCategory;
  const textColor1 = courseCategory?.color
    ? getContrastTextColor(courseCategory.color)
    : "#FFFFFF";
  const textColor2 = courseCategory?.colorVariant1
    ? getContrastTextColor(courseCategory.colorVariant1)
    : "#000000";
  const textColor3 = courseCategory?.colorVariant2
    ? getContrastTextColor(courseCategory.colorVariant2)
    : "#3E3E3E";

  return (
    <CourseContext.Provider value={{}}>
      <div
        style={{
          ["--course-color-1" as string]: courseCategory?.color
            ? courseCategory?.color
            : "var(--brand)",
          ["--course-color-2" as string]: courseCategory?.colorVariant1
            ? courseCategory.colorVariant1
            : "var(--brand-variant-1)",
          ["--course-color-3" as string]: courseCategory?.colorVariant2
            ? courseCategory?.colorVariant2
            : "var(--brand-variant-2)",

          ["--course-color-text-1" as string]: textColor1,
          ["--course-color-text-2" as string]: textColor2,
          ["--course-color-text-3" as string]: textColor3,
        }}
      >
        {children}
      </div>
    </CourseContext.Provider>
  );
};
